export const LayoutMode = {
    DESIGN: 'design',
    CODE: 'code'
} as const;

export type LayoutMode = (typeof LayoutMode)[keyof typeof LayoutMode];
